import { z } from "zod";

import { DbEnum } from "../../../../generated/prisma-enums";

export const GetEmbedSessionsPathVarsSchema = z.object({
  id: z.string().uuid()
});

/**
 * The ids travel in the `x-session-ids` header. The query field is the fallback
 * for widget bundles built before that header existed, and the backend's
 * `getEmbedSessions` carries the `debt:` marker that retires it.
 */
export const GetEmbedSessionsQuerySchema = z.object({
  sessionIds: z.string().optional()
});

export const EmbedSessionSummarySchema = z.object({
  sessionId: z.string(),
  chatId: z.string().uuid(),
  topic: z.string().nullable(),
  lastMessagePreview: z.string().nullable(),
  lastMessageAt: z.string().nullable(),
  messageCount: z.number(),
  /**
   * Underlying chat status. Used by the embed landing screen to decide whether
   * an existing conversation is still "active" (OPEN/RUNNING) or has been
   * closed/archived.
   */
  status: z.nativeEnum(DbEnum.ChatStatus).optional()
});

export const GetEmbedSessionsResponseSchema = z.object({
  sessions: z.array(EmbedSessionSummarySchema)
});

export type GetEmbedSessionsPathVars = z.infer<typeof GetEmbedSessionsPathVarsSchema>;
export type GetEmbedSessionsQuery = z.infer<typeof GetEmbedSessionsQuerySchema>;
export type EmbedSessionSummary = z.infer<typeof EmbedSessionSummarySchema>;
export type GetEmbedSessionsResponse = z.infer<typeof GetEmbedSessionsResponseSchema>;
